import { Box, Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookSparkles } from '@fortawesome/pro-solid-svg-icons';

interface PdfFallbackProps {
  title?: string;
  description?: string;
}

const PdfFallback = ({
  title = 'No Document Available',
  description = 'There is no PDF available to preview at the moment.'
}: PdfFallbackProps) => {
  return (
    <Flex
      flexDirection="column"
      gap={8}
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Box bgColor="neutralSecondaryFill" padding={8} borderRadius="md">
        <FontAwesomeIcon icon={faBookSparkles} fontSize={40} />
      </Box>

      <Flex flexDirection="column" gap={2}>
        <Text textStyle="headingTitle">{title}</Text>
        <Text textStyle="textBody" paddingX={2}>
          {description}
        </Text>
      </Flex>
    </Flex>
  );
};

export default PdfFallback;
